import instance from "./axiosInstance";
import { normalizeUsageReport } from "@/utils/usage";

export const getUserUsage = async (params) => {
  const response = await instance.get("/usage/users", { params });
  const result = response.data;
  if (result.code === 0 && result.data) {
    result.data = normalizeUsageReport(result.data);
  }
  return result;
};
